import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  Collapse,
  Typography,
  Chip,
} from "@material-ui/core";
import Box from '@mui/material/Box';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  getLedgerDetails,
  getCenterInfo,
  getLedgerBalance,
} from "../actions/GenomicsAdminAction";
import { TablePagination } from "@material-ui/core";
import moment from "moment";
import { Button } from "@material-ui/core";
import Loader from "../Components/loader/index";
import Autocomplete from "@material-ui/lab/Autocomplete";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "90%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      borderLeft: "solid 1px #0e416b",
      borderRight: "solid 1px #0e416b",
      borderBottom: "solid 1px #0e416b",
      marginTop: "20px",
      minHeight: "300px",
    },
    table: {
      minWidth: 700,
    },
    tableRow: {
      padding: "5px 0 5px 5px !important",
    },
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  loading: boolean;
  getLedgerDetails: any;
  clientLedgerDetails: any;
  getLedgerBalance: any;
  clientLedgerBalance: any;
  getCenterInfo: any;
  centerInfo: any;
}

const CcLedger: React.FC<Props> = ({
  loading,
  clientLedgerDetails,
  getLedgerDetails,
  getLedgerBalance,
  clientLedgerBalance,
  getCenterInfo,
  centerInfo,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [start_date, setStart_date] = useState<any>("");
  const [startDate, setStartDate] = useState<any>("");
  const [end_date, setEnd_date] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [status, setStatus] = useState<any>("none");
  const [ladgerType, setLedgerType] = useState<any>("none");
  const [center, setCenter] = useState<any>("");
  const [open, setOpen] = useState<boolean>(false);
  const history = useHistory();
  const [centreID, setCentreID] = React.useState<any>("");
  useEffect(() => {
    getLedgerDetails();
    getLedgerBalance();
    getCenterInfo();
  }, []);

  const dispatch = useDispatch();

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        clientLedgerBalance.links &&
        clientLedgerBalance.links.next.split("?")[1];
      getLedgerBalance(url);
    } else if (newPage < page) {
      let url =
        clientLedgerBalance.links &&
        clientLedgerBalance.links.previous.split("?")[1];
      getLedgerBalance(url);
    }
    setPage(newPage);
  };
  const filterHandler = () => {
    getLedgerBalance(`center_id=${center}`);
    setStart_date(startDate);
    setEnd_date(endDate);
    setPage(0);
  };

  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          <h4 style={{ fontWeight: "bold" }}> GENOMICS LEDGER</h4>
        </div>
        <div className={classes.contentFilter}>
          <Grid
            container
            spacing={3}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCenter(obj.id);
                  }
                }}
                freeSolo
                blurOnSelect
                options={centerInfo.results || []}
                getOptionDisabled={(option: any) => {
                  return center.includes(option.id);
                }}
                disableClearable
                disableCloseOnSelect
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                onInputChange={(event, newInputValue) => {
                  getCenterInfo(`&name_or_code=${newInputValue}`);

                  if (newInputValue.length === 0) {
                    setCenter("");
                  } else if (centerInfo.results === 1) {
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    placeholder="Hospital/Doctor"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                className="input"
                name="start_date"
                type="date"
                label="Start Date"
                value={startDate}
                variant="outlined"
                onChange={(e) => setStartDate(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                name="end_date"
                type="date"
                value={endDate}
                className="input"
                label="End Date"
                variant="outlined"
                onChange={(e) => setEndDate(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="secondary"
                style={{ height: "56px" }}
                fullWidth
                onClick={filterHandler}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() =>
                  history.push("/dashboard/gnadmin/ccClientLedgerDetails")
                }
              >
                Reset
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="secondary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() =>
                  history.push("/dashboard/gnadmin/cc_Ledger_export")
                }
              >
                Export
              </Button>
            </Grid>
          </Grid>
        </div>
        <div>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "540px" }}
          >
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">S. NO.</StyledTableCell>
                  <StyledTableCell align="center">Hospital/Doctor Name</StyledTableCell>
                  <StyledTableCell align="center">Hospital/Doctor Code</StyledTableCell>
                  <StyledTableCell align="center">Hospital/Doctor Type</StyledTableCell>
                  <StyledTableCell align="center">Status</StyledTableCell>
                  <StyledTableCell align="center">Balance</StyledTableCell>

                  <StyledTableCell align="center">
                    Total Billing Done
                  </StyledTableCell>

                  <StyledTableCell align="center">More Details</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {clientLedgerBalance.results &&
                  clientLedgerBalance.results.length > 0 &&
                  clientLedgerBalance.results.map((val: any, index: any) => {
                    return (
                      <Row
                        key={val.centre_id}
                        val={val}
                        index={index}
                        open={open}
                        setOpen={setOpen}
                        centreID={centreID}
                        setCentreID={setCentreID}
                        clientLedgerDetails={clientLedgerDetails}
                        getLedgerDetails={getLedgerDetails}
                        loading={loading}
                        start_date={start_date}
                        end_date={end_date}
                      />
                    );
                  })}
              </TableBody>
              <TablePagination
                rowsPerPageOptions={[]}
                colSpan={3}
                count={clientLedgerBalance.count}
                rowsPerPage={clientLedgerBalance.page_size}
                page={page}
                onPageChange={handleChangePage}
              />
            </Table>
          </TableContainer>
        </div>
      </main>
    </>
  );
};
function Row(props: {
  val: any;
  index: any;
  centreID: any;
  setCentreID: any;
  open: any;
  setOpen: any;
  getLedgerDetails: any;
  clientLedgerDetails: any;
  start_date: any;
  end_date: any;
  loading: boolean;
}) {
  const {
    val,
    centreID,
    setCentreID,
    clientLedgerDetails,
    index,
    getLedgerDetails,
    open,
    setOpen,
    start_date,
    end_date,
    loading,
  } = props;
  useEffect(() => {
    if (centreID) {
      getLedgerDetails(
        `center=${centreID}&start_date=${start_date}&end_date=${end_date}`
      );
    }
  }, [start_date, end_date]);

  const setOpenTest = (centreId: number) => {
    getLedgerDetails(
      `center=${centreId}&start_date=${start_date}&end_date=${end_date}`
    );
    setOpen(open);
    setCentreID(centreId);
  };
  const handleDOBForAge = (dob: any, bdate: any) => {
    const a: any = moment(bdate);
    const b: any = moment(dob);
    var years = a.diff(b, "year");
    b.add(years, "years");
    var months = a.diff(b, "months");
    b.add(months, "months");
    var days = a.diff(b, "days");
    if (months !== 0) {
      var age = months + "Months " + days + "Days";
    } else {
      var age = days + "Days";
    }

    return age;
  };
  const classes = useStyles();
  const [printData, setPrintData] = useState<any>([]);
  const [testArray, setTestArray] = useState<any>([]);
  const [page, setPage] = useState(0);
  const history = useHistory();
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        clientLedgerDetails.links &&
        clientLedgerDetails.links.next.split("?")[1];
      getLedgerDetails(url);
    } else if (newPage < page) {
      let url =
        clientLedgerDetails.links &&
        clientLedgerDetails.links.previous.split("?")[1];
      getLedgerDetails(url);
    }
    setPage(newPage as number);
  };
  const handleBill = (cusVisID: any) => {
    //   localStorage.setItem("ccCustomerVisitId", cusVisID);
    //   history.push(`/dashboard/sr/ccBillPdf`);
  };
  return (
    <React.Fragment>
      <StyledTableRow key={val.centre_id} className={classes.tableRow}>
        <StyledTableCell align="center">{index + 1}</StyledTableCell>
        <StyledTableCell align="center">
          {val?.display_name === null ? val?.centre_name : val?.display_name}
        </StyledTableCell>
        <StyledTableCell align="center">{val.code}</StyledTableCell>
        <StyledTableCell align="center">{val.type}</StyledTableCell>
        <StyledTableCell align="center">{val.pre_post}</StyledTableCell>
        <StyledTableCell align="center">
          {Math.round(val.balance).toFixed(2)}
        </StyledTableCell>

        <StyledTableCell align="center">{val.billed_amount}</StyledTableCell>

        <StyledTableCell align="center">
          {" "}
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenTest(val.centre_id)}
            style={{ background: "rgb(63 81 181 / 43%)" }}
          >
            {centreID === val.centre_id ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={10}
        >
          <Collapse
            in={centreID === val.centre_id ? !open : open}
            timeout="auto"
            unmountOnExit
            key={val.centre_id}
          >
            <Box margin={1}>
              <Grid container xs={12}>
                <Grid item xs={11}>
                  <Typography variant="h6" gutterBottom component="div">
                    All Transaction Details
                  </Typography>
                </Grid>
                <Grid item xs={1} style={{ textAlign: "right" }}></Grid>
              </Grid>
              <TableContainer style={{ maxHeight: 350 }}>
                {loading ? (
                  <Loader />
                ) : (
                  <Table size="small" aria-label="purchases" stickyHeader>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          <b>Sr. No.</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Bill No.</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Payment Date</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Patient Name</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Age</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Gender</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Code</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Name</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Remarks</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Is Coupon</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Gross</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Client Share(%)</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Client Share</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Credit/Debit</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>RCL Share</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Balance</b>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {clientLedgerDetails.results &&
                        clientLedgerDetails.results.length > 0 &&
                        clientLedgerDetails.results.map(
                          (qual: any, index: any) => {
                            return (
                              <StyledTableRow>
                                <StyledTableCell align="center">
                                  {index + 1}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.booking}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {moment(qual?.created_at).format(
                                    "DD-MM-YYYY"
                                  )}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.customer_name}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.customer_age === 0
                                    ? handleDOBForAge(
                                        qual?.dob,
                                        qual?.booking_date
                                      )
                                    : qual?.customer_age}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.customer_gender}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.package_code}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.package_name}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <sub>{qual.remarks}</sub>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.camp_coupon}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual.amount}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.client_discount_percentage
                                    ? qual?.client_discount_percentage
                                    : "0"}
                                  %
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {Number(qual.client_share).toFixed(2)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {qual?.ledger_type === "credit" ? (
                                    <Chip
                                      size="small"
                                      label="Credit"
                                      style={{
                                        backgroundColor: "#4caf50",
                                        color: "#fff",
                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      size="small"
                                      label="Debit"
                                      style={{
                                        backgroundColor: "#f44336",
                                        color: "#fff",
                                      }}
                                    />
                                  )}
                                </StyledTableCell>

                                <StyledTableCell align="center">
                                  {Number(qual?.rcl_share).toFixed(2)}
                                </StyledTableCell>

                                <StyledTableCell align="center">
                                  {Number(qual?.center_rem_balance).toFixed(2)}
                                </StyledTableCell>
                              </StyledTableRow>
                            );
                          }
                        )}
                    </TableBody>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      colSpan={3}
                      count={clientLedgerDetails.count}
                      rowsPerPage={clientLedgerDetails.page_size}
                      page={page}
                      onPageChange={handleChangePage}
                    />
                  </Table>
                )}
              </TableContainer>
            </Box>
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}
const mapStateToProps = (state: any) => ({
  clientLedgerDetails: state.GenomicsAdminReducer.clientLedgerDetails,
  clientLedgerBalance: state.GenomicsAdminReducer.clientLedgerBalance,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  loading: state.GenomicsAdminReducer.loading,
});
export default connect(mapStateToProps, {
  getLedgerDetails,
  getCenterInfo,
  getLedgerBalance,
})(CcLedger);
